import { IWorldSettingsAiAssistant } from '@shared/interfaces/world';
import { PollyLanguage, voicesByLanguage } from '@constants/polly';
import { LANGUAGES, POLLY_TO_LANGUAGE_CODE } from '@constants/language';

export const getAiAssistantLanguageCodes = (
  aiAssistant: IWorldSettingsAiAssistant | undefined,
): string[] | undefined => {
  if (!aiAssistant?.baseLanguage && !aiAssistant?.languages?.length) {
    return undefined;
  }

  return (
    [aiAssistant.baseLanguage, ...(aiAssistant.languages ?? [])].filter(
      Boolean,
    ) as PollyLanguage[]
  )
    .filter((lang) => voicesByLanguage[lang])
    .map((lang) => POLLY_TO_LANGUAGE_CODE[lang] ?? lang);
};

export const getAiAssistantLanguageOptions = (
  aiAssistant: IWorldSettingsAiAssistant | undefined,
): Array<{ key: string; label: string }> | undefined => {
  const codes = getAiAssistantLanguageCodes(aiAssistant);

  if (!codes) {
    return undefined;
  }

  return LANGUAGES.filter(({ key }) =>
    codes.some((code) => code.toLowerCase() === key.toLowerCase()),
  );
};
